import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { OuttageComponent } from '../app/components/outtage.component';
@NgModule({
  declarations: [AppComponent, OuttageComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
